let ownersList = [
  {
    img: false,
    name: "Lyle Williams",
    personsTitle: "Director of Sales, Partner",
    // email: "sales@msyapparel.com",
    summary: `"As a former athletic equipment manager with over 20 years of experience who transitioned into owning an apparel and decoration company, my journey represents a unique blend of expertise in sports equipment within the apparel industry.  My journey has given us invaluable insight into the needs, qualities, functionality, and style that are needed in the performance aspect of decorating athletic wear."  
`,
  },
  {
    img: false,
    shapeOfImage: "round",
    name: "Juan Mendieta",
    personsTitle: "Director of Creative Design, Partner",
    // email: "art@msyapparel.com",
    summary: `"Drawing from ten years of dedicated experience in the apparel industry, my expertise spans graphic design, screen printing, embroidery, banners, promotional items, and more. Throughout my extensive journey in this industry, I've gained invaluable insights and forged meaningful connections with industry professionals. Fueled by a commitment to excellence, I persistently work towards elevating our standards, ensuring that the quality of our products consistently stands out and exceeds expectations.
"`,
  },

  {
    img: false,
    name: "Trase Guidry ",
    personsTitle: "Director of Business Operations, Partner",
    // email: "info@msyapparel.com",
    summary: `"With over 15 years of experience in business and as an equipment manager. His expertise lies in crafting business strategies that ensure customer satisfaction through exemplary business practices. With a keen focus on websites and branding, Trase is dedicated to delivering innovative solutions that resonate with audiences and achieve impactful results."`,
  },
  {
    img: false,
    name: "Abbi Guidry",
    personsTitle: "Promotional Sales",
    // email: "Abbi@msyapparel.com",
    summary: `"With over 15 years of experience in marketing and advertising, Abbi leads the promotions and signage division at MSY Apparel. Their expertise lies in developing strategic campaigns that elevate brand visibility and drive engagement. With a keen focus on promotions, websites, signage, and branding, She is dedicated to delivering innovative solutions that resonate with audiences and achieve impactful results."`,
  },
];

export default ownersList;
